import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';
import FadeUp from '../UI/FadeUp';
import './FAQ.css';

const faqs = [
  {
    question: "What are your delivery hours?",
    answer: "We deliver hot and fresh food from 10:00 AM to 11:00 PM every day, including weekends and public holidays."
  },
  {
    question: "How long does delivery usually take?",
    answer: "Delivery typically takes between 30 to 45 minutes. You can track your order in real-time from the kitchen to your doorstep."
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards (Visa, MasterCard, Amex), digital wallets like PayPal and Apple Pay, as well as Cash on Delivery."
  },
  {
    question: "Is there a minimum order amount?",
    answer: "Yes, our minimum order amount is $10 for free delivery. Orders below $10 will incur a small delivery fee."
  }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={onClick}>
        <span>{question}</span>
        <Icon icon={isOpen ? "mdi:minus" : "mdi:plus"} className="faq-icon" />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="faq-answer-wrapper"
          >
            <div className="faq-answer">
              <p>{answer}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq-section">
      <div className="faq-container">
        <FadeUp>
          <div className="faq-header">
            <h2>Frequently Asked Questions</h2>
            <p>Have questions? We're here to help.</p>
          </div>
        </FadeUp>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <FadeUp delay={index * 0.1} key={index}>
              <FAQItem
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index}
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
